//import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import LoadingHook from '../../hooks/LoadingHook'
import { Button, Checkbox, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Action_Admin_user_List, Action_Admin_user_save } from '../../../store/action/action-user';
import SaveIcon from '@material-ui/icons/Save';
import  useTableStyles from '../../../assets/css/materialUI/tableCss'

// const useStyles = makeStyles({ 
//     root: {
//         '& > *': {
//             borderBottom: 'unset',
//         },
//     },
//     tr: {
//         // minWidth: 650,
//         backgroundColor: '#fff !important',
//         cursor: 'pointer',
//         '&:hover': {
//             backgroundColor: '#eee !important',
//         }
//     },
//     ppr: {
//         margin: '2rem',
//         padding: '2rem',
//         maxWidth: 'calc(100% - 4rem)'
//     },
//     tblTitle: {
//         marginBottom: '1.5rem',
//         color: 'blue',
//         fontSize: '1.7rem',
//         borderBottom: '1px solid',
//     },
//     prodImg: {
//         height: '3rem',
//         maxWidth: '3rem',
//         '&:hover': {
//             transform: 'scale(4)',
//             transition: 'all 1s',
//         }
//     },
//     selectable: {
//         '&:hover': {
//             transform: 'scale(1.1)',
//             transition: 'all 0.5s',
//             fontWeight: 700,
//         },
//         cursor: 'pointer',

//     }
//     // tblSubTtl: {
//     //     fontSize: '1.3rem',
//     //     color: '#515194 !important',
//     // }
// });

export default function UsersManagementScreen() {
    const dispatch = useDispatch()
    const classes =  useTableStyles();
    // const classes = useStyles();
    const { users, loading, users_error } = useSelector(state => state.reducer_user)
    const [selectedUser, setSelectedUser] = useState()

    const selectedRow = (user) => {
        console.log('user:', user)
        setSelectedUser(user)
    }
    const saveChagos = async () => {
        if (selectedUser) {
            console.log('selectedUser:', selectedUser)
            await dispatch(Action_Admin_user_save(selectedUser))
            setSelectedUser(undefined)
        }
    }

    useEffect(() => {
        dispatch(Action_Admin_user_List())
    }, [])


    if (loading) {
        return (
            <LoadingHook />
        )
    }

    if (users_error) {
        return (
            <Alert severity="error" style={{ margin: '3rem +5rem' }} >{users_error}</Alert>
        )
    }

    return (
        <div>
            {
                !users ? (
                    <Alert severity="info" style={{ margin: '3rem +5rem' }} >No data</Alert>
                ) :
                    (

                        <TableContainer component={Paper} className={classes.ppr} >
                            <Typography component="h1" gutterBottom className={classes.tblTitle} >
                                Users Managements
                            </Typography>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>_id</TableCell>
                                        <TableCell align="right">Name</TableCell>
                                        <TableCell align="right">Is Admin</TableCell>
                                        <TableCell align="right">is Seller</TableCell>
                                        <TableCell align="right">Email </TableCell>
                                        <TableCell align="right">Picture </TableCell>
                                        <TableCell align="center">Is Super Admin</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {users.map((user) => (

                                        <TableRow key={user._id} onClick={() => selectedRow(user)} hover className={classes.tr}  >

                                            <TableCell component="th" scope="row">
                                                {user._id}
                                            </TableCell>
                                            <TableCell align="right">{user.name}</TableCell>
                                            <TableCell align="right">
                                                <Checkbox
                                                    checked={user.isAdmin || false}
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <Checkbox
                                                    checked={user.isSeller || false}
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            </TableCell>
                                            <TableCell align="right">{user.email}</TableCell>
                                            <TableCell align="right">
                                                <img src={user.picture} alt='user image' className={classes.prodImg} />
                                            </TableCell>
                                            <TableCell align="center">
                                                <Checkbox
                                                    checked={user.isSuperAdmin || false}
                                                    color="primary"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
            {selectedUser &&
                <div>
                    <TableContainer component={Paper} className={classes.ppr} >
                        <Typography component="h1" gutterBottom className={classes.tblTitle} >
                            Selected user: EDIT
                        </Typography>



                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>_id</TableCell>
                                    <TableCell align="right">Name</TableCell>
                                    <TableCell align="right">Is Admin</TableCell>
                                    <TableCell align="right">is Seller</TableCell>
                                    <TableCell align="right">Email </TableCell>
                                    <TableCell align="right">Picture </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        {selectedUser._id}
                                    </TableCell>
                                    <TableCell align="right">{selectedUser.name}</TableCell>
                                    <TableCell align="right">
                                        <Checkbox
                                            onClick={() => setSelectedUser(
                                                { ...selectedUser, isAdmin: !selectedUser.isAdmin }
                                            )}
                                            className={classes.selectable}
                                            checked={selectedUser.isAdmin || false}
                                            color="primary"
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                        />
                                    </TableCell>
                                    <TableCell align="right">
                                        <Checkbox
                                            onClick={() => setSelectedUser(
                                                { ...selectedUser, isSeller: !selectedUser.isSeller }
                                            )}
                                            className={classes.selectable}
                                            checked={selectedUser.isSeller || false}
                                            color="primary"
                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                        />
                                    </TableCell>
                                    <TableCell align="right">{selectedUser.email}</TableCell>
                                    <TableCell align="right">
                                        <img src={selectedUser.picture} alt='user image' className={classes.prodImg} />
                                    </TableCell>
                                </TableRow>
                                {/* <TableRow>
                                    <TableCell >
                                        <Button fullWidth variant="contained" color="secondary">
                                            Save
                                        </Button>
                                    </TableCell>
                                </TableRow> */}

                            </TableBody>
                        </Table>
                        <Button variant="contained" color="secondary" style={{ width: '15rem', margin: '2rem 0' }}
                            size="large"
                            onClick={saveChagos}
                            startIcon={<SaveIcon />}>
                            Save
                        </Button>

                    </TableContainer>

                </div>

            }
        </div>

    )
}


